import { financialConfirmationInterceptor } from 'shared-ui';
import { environment } from '../environments/environment';
import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withNavigationErrorHandler } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { AuthExpiredInterceptor } from './core/interceptors/auth-expired.interceptor';
import { WithCredentialsInterceptor } from './core/interceptors/with-credentials.interceptor';
import { isStaleChunkError, reloadForStaleChunk } from './core/stale-chunk/stale-chunk';
import { providePrimeNG } from 'primeng/config';
import {
  APEX_THEME_STORAGE_KEY,
  APEX_THEME_STORAGE_KEYS,
  ApexPrimeNgPreset,
  ApexThemeService,
} from 'shared-ui';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    { provide: APEX_THEME_STORAGE_KEY, useValue: APEX_THEME_STORAGE_KEYS.tenant },
    provideAppInitializer(() => {
      inject(ApexThemeService);
    }),
    providePrimeNG({
      theme: {
        preset: ApexPrimeNgPreset,
        options: {
          darkModeSelector: "html[data-theme='dark']",
        },
      },
    }),
    provideRouter(
      routes,
      // The router catches lazy-load failures itself, so a stale tab after a deploy must be handled here.
      withNavigationErrorHandler((error) => {
        if (typeof window !== 'undefined' && isStaleChunkError(error.error)) {
          reloadForStaleChunk(error.url);
        }
      }),
    ),
    { provide: HTTP_INTERCEPTORS, useClass: WithCredentialsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthExpiredInterceptor, multi: true },
    provideHttpClient(withFetch(), withInterceptors([financialConfirmationInterceptor(environment.apiGatewayUrl)]), withInterceptorsFromDi()),
    provideClientHydration(withEventReplay()),
  ],
};
